"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogueSystem = void 0;
const Constants_1 = require("../../../Shared/Constants");
const gotti_1 = require("gotti");
var EventEmitter = PIXI.utils.EventEmitter;
const Utils_1 = require("../../../Shared/Utils");
class ResponseContainer extends PIXI.Container {
    constructor(bg, longBackground, tall, pointerTexture, selectedOptionBackground) {
        super();
        this.responses = [];
        this.selectedResponseIndex = 0;
        this.movePointerDirection = -1;
        this.tallBackgroungTexture = tall;
        this.smallBackgroundTexture = bg;
        this.longBackgroundTexture = longBackground;
        this.backgroundSprite = new PIXI.Sprite(bg);
        this.addChild(this.backgroundSprite);
        this.selectedChoiceBackgroundSprite = new PIXI.Sprite(selectedOptionBackground);
        this.addChild(this.selectedChoiceBackgroundSprite);
        this.pointerSprite = new PIXI.Sprite(pointerTexture);
        this.addChild(this.pointerSprite);
        this.pointerSprite.x = -this.pointerSprite.width;
    }
    updatePointer(delta) {
        if (!this.visible)
            return;
        const maxX = -this.pointerSprite.width;
        const minX = maxX - 8;
        this.pointerSprite.x += delta * this.movePointerDirection;
        if (this.pointerSprite.x <= minX) {
            this.movePointerDirection = 1;
        }
        else if (this.pointerSprite.x >= maxX) {
            this.movePointerDirection = -1;
        }
    }
    show(options) {
        this.clear();
        let needsLong = false;
        let texture = this.smallBackgroundTexture;
        this.y = -10;
        options.forEach(o => {
            if (o.text.length > 10) {
                texture = this.longBackgroundTexture;
            }
        });
        if (options.length >= 4) {
            this.y = -85;
            texture = this.tallBackgroungTexture;
        }
        let y = 5;
        this.backgroundSprite.texture = texture;
        this.responses = options.map((o, i) => {
            const text = new PIXI.extras.BitmapText(o.text, { font: 'gold2' });
            text.maxWidth = texture.width;
            this.addChild(text);
            text.updateTransform();
            text.y = y;
            y += (text.height + 5);
            text.x = 5;
            return { text, callback: o.callback };
        });
        this.visible = true;
        this.setSelected(0);
    }
    clear() {
        this.visible = false;
        this.responses.forEach(r => r.text.destroy());
        this.responses.length = 0;
        this.selectedResponseIndex = 0;
    }
    doSelectedCallback() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.responses[this.selectedResponseIndex].callback();
        });
    }
    setSelected(index) {
        this.selectedResponseIndex = index;
        if (this.responses[index]) {
            this.pointerSprite.y = this.responses[index].text.y;
            this.selectedChoiceBackgroundSprite.y = this.responses[index].text.y;
        }
    }
    moveUpSelected() {
        if (this.selectedResponseIndex >= this.responses.length - 1) {
            this.setSelected(0);
        }
        else {
            this.setSelected(this.selectedResponseIndex + 1);
        }
    }
    moveDownSelected() {
        if (this.selectedResponseIndex === 0) {
            this.setSelected(Math.max(this.responses.length - 1, 0));
        }
        else {
            this.setSelected(this.selectedResponseIndex - 1);
        }
    }
}
class NameLabel extends PIXI.Container {
    constructor(texturesBySize) {
        super();
        this.backgroundSprite = new PIXI.Sprite();
        //console.error('textures:', texturesBySize);
        this.text = new PIXI.extras.BitmapText('', { font: 'gold' });
        this.textures = texturesBySize;
        this.addChild(this.backgroundSprite);
        this.addChild(this.text);
        this.x = -5;
    }
    setName(n, textures) {
        textures = textures || this.textures;
        let prevName = this.text.text;
        this.text.text = n;
        if (n && n !== prevName) {
            try {
                this.text.updateTransform();
            }
            catch (err) {
                //console.error(err);
            }
            for (let i = 0; i < textures.length; i++) {
                const t = textures[i];
                if (this.text.width < t.width) {
                    this.text.x = (t.width / 2) - (this.text.width / 2);
                    this.backgroundSprite.texture = t;
                    break;
                }
                else if (i === textures.length - 1) {
                    this.backgroundSprite.texture = t;
                    this.text.x = (this.text.width - t.width) / 2;
                }
            }
            //console.error('the label was', this.backgroundSprite.texture);
            this.text.y = (this.backgroundSprite.texture.height) / 2 - (this.text.height / 2);
            this.y = -((this.backgroundSprite.texture.height / 2) + 3);
        }
    }
}
class DialogueSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.DIALOGUE);
        this._curNpc = '';
        this.container = new PIXI.Container();
        this.backgroundSprite = new PIXI.Sprite();
        this.awaitingContinueComments = false;
        this.awaitingUserResponse = false;
        this.continueBtn = new PIXI.Graphics();
        this.grabCooldown = 0;
        this.dialogueEventEmitter = new EventEmitter();
        this.recenterInterface = this.recenterInterface.bind(this);
        this.playerNpcDialogueCollisionPlugin = {
            type: 'collision',
            name: 'dialogue',
            tagAs: [Constants_1.COLLIDER_TAGS.in_front_of_client_player],
            tagBs: [Constants_1.COLLIDER_TAGS.npc],
            onCollisionStart: (colA, colB) => {
                if (!this.focusedNpc) {
                    this.focusedNpc = colB.gameObject.entity;
                }
            },
            onCollision: (colA, colB) => {
                if (!this.focusedNpc) {
                    this.focusedNpc = colB.gameObject.entity;
                }
            },
            onCollisionEnd: (colA, colB) => {
                if (this.focusedNpc === colB.gameObject.entity) {
                    this.focusedNpc = null;
                }
            },
        };
    }
    displayComment(comment, from) {
        return __awaiter(this, void 0, void 0, function* () {
            this.responseContainer.clear();
            const textures = from === "Nom Took" || from === "nomTook" ? [this.globals.gameTextures.dialogue.nomTookBackground] : null;
            this.nameLabel.setName(from, textures);
            this.awaitingContinueComments = true;
            this.dialogueText.text = comment;
            return new Promise((resolve, reject) => {
                this.dialogueEventEmitter.once('next-comment', () => {
                    //console.error('finished comment.')
                    this.awaitingContinueComments = false;
                    return resolve(true);
                });
            });
        });
    }
    get curNpc() {
        return this._curNpc;
    }
    set curNpc(v) {
        this._curNpc = v;
    }
    resolveLoopedDialogueText(r, curIteration) {
    }
    resolveResponseText(r) {
        //console.error('resolveResponseText, response: ', r);
        if (r.sellBumbleBeeOption) {
            return 'Sell Bees';
        }
        else if (r.sellFlowersOption) {
            return 'Sell Flowers';
        }
        else if (r.openShopOption) {
            return 'Open Shop';
        }
        else if (r.response) {
            return r.response;
        }
    }
    resolveResponseCallback(r, fromDialogue) {
        //console.error('resolveResponseCallback, response: ', r, 'from dialogue:', fromDialogue);
        if (r.sellBumbleBeeOption) {
            return r.sellBumbleBeeOption;
        }
        else if (r.sellFlowersOption) {
            return r.sellFlowersOption;
        }
        else if (r.openShopOption) {
            return r.openShopOption;
        }
        else if (r.reply) {
            const promise = () => __awaiter(this, void 0, void 0, function* () {
                return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                    yield this.startDialogue(r.reply, this.curNpc);
                    if (fromDialogue && r.loopBack) {
                        const copied = {
                            npcQuestion: fromDialogue.npcQuestion,
                            responses: fromDialogue.responses,
                        };
                        yield this.startDialogue(copied, this.curNpc);
                    }
                    return resolve(true);
                }));
            });
            return promise;
        }
        else if (r.response) {
            return () => { };
        }
        else {
            throw new Error(`Invalid response: ${r}`);
        }
    }
    drawResponses(responses, fromDialogue) {
        const options = responses.filter(r => {
            if ('sellBumbleBeeOption' in r && !r.sellBumbleBeeOption)
                return false;
            if ('sellFlowersOption' in r && !r.sellFlowersOption)
                return false;
            //todo: looped dialogue not working yet.
            if ('loopedDialogue' in r)
                return false;
            return true;
        }).map(r => {
            return {
                text: this.resolveResponseText(r),
                callback: this.resolveResponseCallback(r, fromDialogue),
            };
        });
        //console.error('response options becam,e', options);
        this.responseContainer.show(options);
    }
    drawText(text, index = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            if (index === 0) {
                this.dialogueText.text = '';
                this.curDrawText = text;
            }
            else {
                if (this.curDrawText !== text)
                    return;
            }
            if (index === text.length - 1) {
                return;
            }
            else {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        return this.drawText(text, ++index);
                    }, 10);
                });
            }
        });
    }
    displayQuestion(question, responses, fromDialogue) {
        return __awaiter(this, void 0, void 0, function* () {
            this.awaitingUserResponse = true;
            const textures = this.curNpc === "Nom Took" || this.curNpc === "nomTook" ? [this.globals.gameTextures.dialogue.nomTookBackground] : null;
            this.nameLabel.setName(this.curNpc, textures);
            this.dialogueText.text = question;
            this.drawResponses(responses, fromDialogue);
            return new Promise((resolve, reject) => {
                this.dialogueEventEmitter.once('answered-question', () => __awaiter(this, void 0, void 0, function* () {
                    this.awaitingUserResponse = false;
                    yield this.responseContainer.doSelectedCallback();
                    return resolve();
                }));
            });
        });
    }
    startDialogue(d, npc = 'Nom Took', closeWhenDone = false) {
        return __awaiter(this, void 0, void 0, function* () {
            npc = npc === "nomTook" ? "Nom Took" : npc;
            this.curNpc = npc;
            this.responseContainer.clear();
            //console.error('startDialogue: STARTING DIALOGUE', d, 'WITH NPC', npc, this.container);
            if (!this.container.visible) {
                this.dialogueText.text = '';
                this.container.visible = true;
            }
            if (d.playerComment) {
                yield this.displayComment(d.playerComment, this.globals.clientPlayer.gameState.playerName);
            }
            if (d.npcComments) {
                for (let i = 0; i < d.npcComments.length; i++) {
                    const commentString = Array.isArray(d.npcComments[i]) ? Utils_1.getRandomItemFromArray(d.npcComments[i]) : d.npcComments[i];
                    yield this.displayComment(commentString, npc);
                }
            }
            if (d.npcQuestion && d.singleResponse)
                throw new Error(`Npc should not ask question with a single response.`);
            if (d.npcQuestion) {
                yield this.displayQuestion(d.npcQuestion, d.responses, d);
            }
            else if (d.singleResponse) {
                yield this.displayComment(d.singleResponse.response, this.globals.clientPlayer.gameState.playerName);
                return this.startDialogue(d.singleResponse.reply, this.curNpc);
            }
        });
    }
    onClear() {
    }
    onLocalMessage(message) {
    }
    onPeerMessage(peerId, message) {
    }
    onInit() {
        this.addApi(this.isInDialogueResponse);
        this.addApi(this.isInDialogue);
        this.globals.tileWorld.use(this.playerNpcDialogueCollisionPlugin);
        this.addApi(this.doDialogue);
    }
    onStart() {
        this.backgroundSprite.texture = this.globals.gameTextures.dialogue.npc.dialogueBackground;
        this.container.addChild(this.backgroundSprite);
        this.container.visible = false;
        const { background, selectedOptionBackground, pointer, longBackground, tallBackground } = this.globals.gameTextures.dialogue.response;
        const { small, medium, large } = this.globals.gameTextures.dialogue.name;
        this.responseContainer = new ResponseContainer(background, longBackground, tallBackground, pointer, selectedOptionBackground);
        this.responseContainer.clear();
        this.responseContainer.x = (this.dialogueWidth - 12);
        this.dialogueText = new PIXI.extras.BitmapText('', { font: 'gold2' });
        this.container.addChild(this.dialogueText);
        this.container.addChild(this.continueBtn);
        this.nameLabel = new NameLabel([small, medium, large]);
        this.container.addChild(this.nameLabel);
        this.continueBtn.x = this.backgroundSprite.texture.width / 2 - (this.continueBtn.width / 2);
        this.continueBtn.y = this.backgroundSprite.texture.height - (this.continueBtn.height + 1);
        this.recenterInterface();
        this.container.addChild(this.responseContainer);
        this.globals.tileWorld.interfaceManager.addChild(this.container);
        this.dialogueText.maxWidth = this.dialogueWidth - 20;
        this.dialogueText.y = 12;
        this.dialogueText.x = 12;
    }
    isInDialogueResponse() {
        return this.responseContainer.visible;
    }
    isInDialogue() {
        return this.container.visible;
    }
    get isInResponse() {
        return this.responseContainer.visible;
    }
    get grabIsCoolingDown() {
        return this.grabCooldown !== 0;
    }
    onServerMessage(message) {
    }
    doNextDialogue() {
    }
    get dialogueWidth() {
        return this.globals.gameTextures.dialogue.npc.dialogueBackground.width;
    }
    get dialogueHeight() {
        return this.globals.gameTextures.dialogue.npc.dialogueBackground.height;
    }
    canDoInputAction(inputKey) {
        return this.previousInput && !this.previousInput[inputKey];
    }
    onStop() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.recenterInterface);
        }
        else if (typeof document !== 'undefined') {
            document.removeEventListener('resize', this.recenterInterface);
        }
    }
    recenterInterface() {
        const screenWidth = this.globals.renderer.screen.width;
        const screenHeight = this.globals.renderer.screen.height;
        this.container.x = (screenWidth / 2) - (this.dialogueWidth / 2);
        this.container.y = (screenHeight) - (this.dialogueHeight + 10);
    }
    doDialogue(d, name) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.startDialogue(d, name);
            this.container.visible = false;
            this.curNpc = '';
            return;
        });
    }
    update(delta) {
        var _a;
        const timeout = .3; //usualy .3
        if (this.grabCooldown > 0) {
            this.grabCooldown = Math.max(0, this.grabCooldown - delta);
        }
        if (this.globals.clientPlayer) {
            const { grab, moveDown, moveUp } = this.globals.clientPlayer.playerInput;
            if (grab) {
                if (this.grabIsCoolingDown)
                    return;
                if (this.isInDialogue()) {
                    if (this.awaitingContinueComments) {
                        this.dialogueEventEmitter.emit('next-comment');
                        this.grabCooldown = timeout;
                    }
                    else if (this.awaitingUserResponse) {
                        this.dialogueEventEmitter.emit('answered-question');
                        this.grabCooldown = timeout;
                    }
                }
                else if (this.focusedNpc && !this.$api.isInventoryOpen() && !this.$api.isShopOpen()) {
                    this.grabCooldown = timeout;
                    const d = (_a = this.focusedNpc) === null || _a === void 0 ? void 0 : _a.getNextDialogue();
                    if (d) {
                        this.doDialogue(d).then(() => {
                            var _a;
                            ((_a = this.focusedNpc) === null || _a === void 0 ? void 0 : _a.nextDialogueCallback) && this.focusedNpc.nextDialogueCallback();
                        });
                    }
                    //  this.startDialogue(this.focusedNpc.getNextDialogue());
                }
            }
            else if ((moveDown && this.canDoInputAction('moveDown')) || (moveUp && this.canDoInputAction('moveUp'))) {
                if (this.awaitingUserResponse) {
                    if (moveDown) {
                        //backwarrds but idfaf atm
                        this.responseContainer.moveUpSelected();
                    }
                    else if (moveUp) {
                        this.responseContainer.moveDownSelected();
                    }
                }
            }
            if (this.awaitingUserResponse) {
                this.responseContainer.updatePointer(delta * 15);
            }
            this.previousInput = Object.assign({}, this.globals.clientPlayer.playerInput);
        }
    }
}
exports.DialogueSystem = DialogueSystem;
//# sourceMappingURL=module.js.map